import dom from './dom'

/**
 * position: fixed;
 * width: 100%;
 * height: 100%;
 */

var scrollLocker = (function (bodyCls) {
  var scrollTop
  return {
    lock: function () {
      scrollTop = document.scrollingElement.scrollTop
      dom.addClass(document.body, bodyCls)
      document.body.style.top = -scrollTop + 'px'
    },
    unlock: function () {
      dom.removeClass(document.body, bodyCls)
      // scrollTop lost after set position:fixed, restore it back.
      document.scrollingElement.scrollTop = scrollTop
    }
  }
})('scroll-lock')

export default scrollLocker



// WEBPACK FOOTER //
// ./src/utils/scroll-lock.js